import styled from "styled-components";

export const H1 = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

export const H2 = styled.h2`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const P = styled.p`
  font-size: 1.2rem;
  margin: 0;
  padding: clamp(10px, 2vw, 30px);
`;